<template>
  <v-layout
    wrap
    align-center
    justify-start
  >
    <v-flex
      xs12
      sm6
      md4
    >
      <DirectionSelect
        class="ma-1"
        @input="() => $emit('input')"
      />
    </v-flex>
    <v-flex
      xs12
      sm6
      md4
    >
      <ArrivalCountrySelect
        class="ma-1"
        @input="() => $emit('input')"
      />
    </v-flex>
    <v-flex
      xs12
      sm6
      md4
    >
      <SendingCountrySelect
        class="ma-1"
        @input="() => $emit('input')"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import DirectionSelect from "../components/DirectionSelect";
import ArrivalCountrySelect from "../components/ArrivalCountrySelect";
import SendingCountrySelect from "../components/SendingCountrySelect";

export default {
  components: {
    DirectionSelect,
    ArrivalCountrySelect,
    SendingCountrySelect,
  },
};
</script>
